<div class="pagination-custom-bootstrap" *ngIf="pageCount > 1">
  <nav>
    <ul class="pagination">
      <li class="page-item" *ngIf="ShowFirstLast">
        <button class="page-link"
          [disabled]='pageIndex == 0'
          (click)="page.emit(pageIndex = 0)">
          {{'pagination.First page' | translate}}
        </button>
      </li>
      <li class="page-item mr-3">
        <button class="page-link"
          [disabled]='pageIndex == 0'
          (click)="page.emit(pageIndex - 1)">
          {{'pagination.Previous' | translate}}
        </button>
      </li>

      <li class="page-item" *ngIf="startPage > 0">
        ...
      </li>
      <li class="page-item" *ngFor="let i of pages">
        <button class="page-link num" (click)="page.emit(i)" [class.active]='pageIndex == i'>
          {{i + 1}}
        </button>
      </li>
      <li class="page-item" *ngIf="pageCount > endPage">
        ...
      </li>

      <li class="page-item ml-3">
        <button class="page-link"
          [disabled]='pageIndex == (pageCount - 1)'
          (click)="page.emit(pageIndex + 1)">
          {{'pagination.Next' | translate}}
        </button>
      </li>
      <li class="page-item" *ngIf="ShowFirstLast">
        <button class="page-link"
          [disabled]='pageIndex == (pageCount - 1)'
          (click)="page.emit(pageCount - 1)">
          {{'pagination.Last page' | translate}}
        </button>
      </li>

    </ul>
  </nav>
</div>
